import {Component, OnInit} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UserMgmtService} from '../../@shared/new-services/user-mgmt.service';
import {CacheService} from '../../@shared/services/cache.service';
import {NotificationService} from '../../@shared/new-services/notification.service';

@Component({
    selector: 'app-add-edit-user-form',
    templateUrl: './add-edit-user-form.component.html',
    styleUrls: ['./add-edit-user-form.component.scss']
})
export class AddEditUserFormComponent implements OnInit {

    breadcrumbMenuModel: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    mode: 'add';
    displayBasicDetailsDialog: boolean;
    userBasicDetailsForm: FormGroup;
    roles: any;
    confirmPassword = '';
    selectedUser: any;
    userDetailsForm: FormGroup;
    businessEntities: any;
    businessEntitiesGroups: any;
    domains: any;
    domainGroups: any;
    displayBusinessEntityGroupCreation: boolean;
    userToManage: any;
    businessEntityGroupForm: FormGroup;
    displayDomainGroupCreation: boolean;
    domainGroupForm: FormGroup;
    businessEntityGroupAction: string;
    domainGroupAction: string;
    countries: any;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');
    isWhatsAppOpted = false;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private userMgmtService: UserMgmtService,
                private messageService: MessageService,
                private cacheService: CacheService,
                private notificationService: NotificationService) {
    }

    ngOnInit(): void {
        this.getRoles();
        this.getBusinessEntities();
        this.getBusinessEntityGroup();
        this.getDomains();
        this.getDomainGroup();
        this.createUserBasicDetailsForm();
        this.createUserDetailsForm();
        this.createBusinessEntityGroupForm();
        this.createDomainGroupForm();
        this.getCountries();
        this.activatedRoute
            .queryParams
            .subscribe(
                (params: any) => {
                    this.mode = params.mode;
                    if (this.mode !== 'add') {
                        this.getUserByUserId(params?.userId);
                    } else {
                        this.displayBasicDetailsDialog = true;
                    }
                }
            );
    }

    navigateToUserManagement(action: any) {
        if (action === 'cancel') {
            this.router
                .navigate(
                    ['/', 'user-management']
                );
            return;
        }
    }

    getRoles() {
        this.userMgmtService
            .getRoles()
            .subscribe((roles) => {
                this.roles = roles;
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    getBusinessEntities() {
        this.userMgmtService
            .getBusinessEntities()
            .subscribe((businessEntities) => {
                    this.businessEntities = businessEntities;
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                }
            );
    }

    getBusinessEntityGroup() {
        this.userMgmtService
            .getBusinessEntityGroups()
            .subscribe((businessEntitiesGroups) => {
                this.businessEntitiesGroups = businessEntitiesGroups;
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    getDomains() {
        this.userMgmtService
            .getDomains()
            .subscribe((domains) => {
                this.domains = domains;
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    getDomainGroup() {
        this.userMgmtService
            .getDomainGroups()
            .subscribe((domainGroups) => {
                this.domainGroups = domainGroups;
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    getCountries() {
        this.userMgmtService
            .getCountries()
            .subscribe(
                (countries) => {
                    this.countries = countries;
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                }
            );
    }

    getUserByUserId(userId: any) {
        this.userMgmtService
            .getUserByUserId(userId)
            .subscribe((user) => {
                this.userToManage = user;
                if (user?.whatsappPhoneNumber && user?.whatsappPhoneStdCode) {
                    this.isWhatsAppOpted = true;
                } else {

                    this.isWhatsAppOpted = false;
                }
                this.breadcrumbMenuModel = [
                    {label: 'User Management', routerLink: '/user-management'},
                    {label: 'Update User : ' + this.userToManage?.username}
                ];
                this.createUserDetailsForm(user);
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    manageBusinessEntityGroup(action: string, businessEntityGroup?: any) {
        this.displayBusinessEntityGroupCreation = true;
        this.businessEntityGroupAction = action;
        if (action === 'new') {
            this.createBusinessEntityGroupForm();
            return;
        }
        if (action === 'edit') {
            this.createBusinessEntityGroupForm(businessEntityGroup);
            return;
        }
    }

    manageDomainGroup(action: string, domainGroup?: any) {
        this.displayDomainGroupCreation = true;
        this.domainGroupAction = action;
        if (action === 'new') {
            this.createDomainGroupForm();
            return;
        }
        if (action === 'edit') {
            this.createDomainGroupForm(domainGroup);
            return;
        }
    }

    handleBusinessEntityGroup() {
        const businessEntityGroup = this.businessEntityGroupForm.value;
        if (this.businessEntityGroupAction === 'new') {
            this.userMgmtService
                .createBusinessEntityGroup(businessEntityGroup)
                .subscribe((businessEntityGroupRes) => {
                    this.displayBusinessEntityGroupCreation = false;
                    this.getBusinessEntityGroup();
                    this.presentToastMessage('success', 'Business Entity Group ' + businessEntityGroupRes?.groupName + ' Created !');
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                });
            return;
        }
        if (this.businessEntityGroupAction === 'edit') {
            this.userMgmtService
                .updateBusinessEntityGroup(businessEntityGroup)
                .subscribe((businessEntityGroupRes) => {
                    this.displayBusinessEntityGroupCreation = false;
                    this.getBusinessEntityGroup();
                    this.presentToastMessage('success', 'Business Entity Group ' + businessEntityGroupRes?.groupName + ' Updated !');
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                });
            return;
        }
    }

    handleDomainGroup() {
        const domainGroup = this.domainGroupForm.value;
        if (this.domainGroupAction === 'new') {
            this.userMgmtService
                .createDomainGroup(domainGroup)
                .subscribe((domainGroupRes) => {
                    this.displayDomainGroupCreation = false;
                    this.getDomainGroup();
                    this.presentToastMessage('success', 'Domain Group ' + domainGroupRes?.domainGroupName + ' Created !');
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                });
            return;
        }
        if (this.domainGroupAction === 'edit') {
            this.userMgmtService
                .updateDomainGroup(domainGroup)
                .subscribe((domainGroupRes) => {
                    this.displayDomainGroupCreation = false;
                    this.getDomainGroup();
                    this.presentToastMessage('success', 'Domain Group ' + domainGroupRes?.domainGroupName + ' Updated !');
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                });
            return;
        }
    }

    createUserWithBasicDetails() {

        this.userBasicDetailsForm.controls.email.setValue(this.userBasicDetailsForm.value.username);
        if (!this.userBasicDetailsForm.valid) {
            this.presentToastMessage('error', 'Please Fill Up All * Fields');
            return;
        }


        const signUpRequest = this.userBasicDetailsForm.value;

        if (this.confirmPassword !== signUpRequest.password) {
            this.presentToastMessage('error', 'Password & Confirm Password Not Matched !');
            return;
        }


        this.userMgmtService.signUpNewBasicUser(signUpRequest)
            .subscribe((x) => {
                this.presentToastMessage('success', 'User Registered Successfully !');
                x = x ? JSON.parse(x) : x;
                this.getUserByUserId(x.userId);
                this.displayBasicDetailsDialog = false;
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    updateUserDetails() {
        const userDetailsFormValue = this.userDetailsForm.value;

        if (!userDetailsFormValue?.whatsappPhoneNumber && userDetailsFormValue?.whatsappPhoneStdCode) {
            this.presentToastMessage('info', 'Please Provide Whatsapp Number or Remove Std Code');
            return;
        }

        if (userDetailsFormValue?.whatsappPhoneNumber && !userDetailsFormValue?.whatsappPhoneStdCode) {

            this.presentToastMessage('info', 'Please Provide Std Code or Remove WhatsApp Number');
            return;
        }

        if (userDetailsFormValue?.whatsappPhoneNumber && userDetailsFormValue?.whatsappPhoneStdCode) {
            userDetailsFormValue.whatsappPhoneNumber = userDetailsFormValue?.whatsappPhoneNumber.toString();
        }

        this.userMgmtService
            .updateUserDetails(userDetailsFormValue)
            .subscribe(
                (user) => {
                    this.presentToastMessage('success', 'User Details Updated Successfully!');
                    this.createUserDetailsForm(user);
                }, (error) => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                }
            );
    }

    whatsAppOptIn(phoneNumber: any, stdCode: any) {
        if (phoneNumber && !stdCode) {
            this.presentToastMessage('info', 'Please Selected STD Code');
            return;
        }
        if (!phoneNumber && stdCode) {
            this.presentToastMessage('info', 'Please Enter Whatsapp Number');
            return;
        }
        if (!phoneNumber && !stdCode) {
            this.presentToastMessage('info', 'Please Enter Whatsapp Number & STD Code to OptIn');
        }
        this.notificationService
            .whatsAppOptIn(phoneNumber, stdCode)
            .subscribe((res) => {
                this.isWhatsAppOpted = true;
                this.presentToastMessage('success', 'WhatsApp OptIn SuccessFully !');
            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });

        this.updateUserDetails();

    }

    whatsAppOptOut(phoneNumber: any, stdCode: any) {
        this.notificationService
            .whatsAppOptOut(phoneNumber, stdCode)
            .subscribe((res) => {

                this.isWhatsAppOpted = false;
                this.presentToastMessage('success', 'WhatsApp OptOut SuccessFully !');

            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });

        const userDetailsForm = this.userDetailsForm.value;
        userDetailsForm.whatsappPhoneStdCode = null;
        userDetailsForm.whatsappPhoneNumber = null;

        this.updateUserDetails();

    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'User Message !',
                    key: 'manage-user-message',
                    detail,
                }
            );
    }

    createUserBasicDetailsForm() {

        this.userBasicDetailsForm = new FormGroup(
            {
                username: new FormControl('', [Validators.required,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
                email: new FormControl(),
                roles: new FormControl(['ROLE_USER'], [Validators.required]),
                password: new FormControl('', [Validators.required])
            }
        );
    }

    createUserDetailsForm(user?: any) {

        this.userDetailsForm = new FormGroup(
            {
                userId: new FormControl(user?.userId ? user?.userId : ''),
                firstName: new FormControl(user?.firstName ? user?.firstName : ''),
                lastName: new FormControl(user?.lastName ? user?.lastName : ''),
                phoneNumber: new FormControl(user?.phoneNumber ? user?.phoneNumber : ''),
                businessEntities: new FormControl(user?.businessEntities ? user?.businessEntities : []),
                businessEntityGroup: new FormControl(user?.businessEntityGroup ? user?.businessEntityGroup : null),
                domains: new FormControl(user?.domains ? user?.domains : []),
                domainGroup: new FormControl(user?.domainGroup ? user?.domainGroup : null),
                whatsappPhoneStdCode: new FormControl(user?.whatsappPhoneStdCode ? user?.whatsappPhoneStdCode : null),
                whatsappPhoneNumber: new FormControl(user?.whatsappPhoneNumber ? user?.whatsappPhoneNumber : null),
                notificationEmail: new FormControl(user?.notificationEmail ? user?.notificationEmail : null)
            }
        );

    }

    createBusinessEntityGroupForm(businessEntityGroup?: any) {
        this.businessEntityGroupForm = new FormGroup({
            businessEntityGroupId: new FormControl(businessEntityGroup?.businessEntityGroupId
                ? businessEntityGroup?.businessEntityGroupId : null),
            businessEntities: new FormControl(businessEntityGroup?.businessEntities ? businessEntityGroup?.businessEntities : []),
            groupName: new FormControl(businessEntityGroup?.groupName ? businessEntityGroup?.groupName : '')
        });
    }

    createDomainGroupForm(domainGroup?: any) {
        this.domainGroupForm = new FormGroup({
            domainGroupId: new FormControl(domainGroup?.domainGroupId
                ? domainGroup?.domainGroupId : null),
            domains: new FormControl(domainGroup?.domains ? domainGroup?.domains : []),
            domainGroupName: new FormControl(domainGroup?.domainGroupName ? domainGroup?.domainGroupName : '')
        });
    }


}
